import React from 'react'
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { techBlack } from '../../utils/constant';

function Dotlottie() {

    return (
        <DotLottieReact
          src="/images/common/BBY Ads Logo Web 122024.lottie"
          loop={false}
          autoplay
          backgroundColor={techBlack}
          style={{width:'204px', height:'30px'}}
        />
      );
}

export default Dotlottie